"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_fetch_1 = require("@biw/client-fetch");
var action_types_1 = require("./action-types");
exports.fetchClientData = function () { return client_fetch_1.clientFetch({
    url: '/api/v1.0/viewConfig/client',
    type: action_types_1.CLIENT
}); };
exports.fetchCompanyBrandingAndRules = function () { return client_fetch_1.clientFetch({
    url: '/api/v1.0/company-branding-and-rules',
    type: action_types_1.CLIENT
}); };
exports.fetchClientCountries = function () { return client_fetch_1.clientFetch({
    url: '/api/v1.0/client-country',
    type: action_types_1.CLIENT_COUNTRY
}); };
//# sourceMappingURL=api.js.map